import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

const withAuthRedirect = (WrappedComponent) => {
  const AuthRedirectComponent = (props) => {
    const history = useHistory();

    useEffect(() => {
      async function checkAuth() {
        try {
          // Make an API request to check the authentication status
          const response = await axios.get("/api/rooms/status");
          // Process the response data...
        } catch (error) {
          if (error.response && error.response.status === 401) {
            sessionStorage.setItem("redirectUrl", window.location.pathname);
            history.push("/login");
          } else {
            // Handle other errors...
          }
        }
      }

      checkAuth();
    }, [history]);

    return <WrappedComponent {...props} />;
  };

  return AuthRedirectComponent;
};

export default withAuthRedirect;
